import Vue from 'vue'

// Sentry
import * as Sentry from '@sentry/vue'
import { Integrations } from '@sentry/tracing'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    Vue: Vue,
    dsn: 'https://6a48f158d6534e7d892ea7b53ec8633e@o109808.ingest.sentry.io/5357130',
    integrations: [new Integrations.BrowserTracing()],
    tracesSampleRate: 1.0,
  })
}

import App from '@/App.vue'
import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'

import '@/plugins/api'
import '@/plugins/cleave'
import '@/plugins/clipboard'
import '@/plugins/components'
import '@/plugins/cookie'
import '@/plugins/currency'
import '@/plugins/download'
import '@/plugins/filters'
import '@/plugins/icons'
import '@/plugins/loadscript'
import '@/plugins/meta'
import '@/plugins/moment'
import '@/plugins/portal'
import '@/plugins/reveal'
import '@/plugins/submitting'
import '@/plugins/toasts'
import '@/plugins/tooltips'

import '@/assets/css/style.css'

Vue.config.productionTip = false

sync(store, router)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
